import type { PlaceFeature } from "~/lib/api";

/** GeoJSON Feature id is string | number | undefined, but our backend always uses string UUIDs */
export const getPlaceId = (place: PlaceFeature): string => place.id as string;
